import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AutoOutgoingRule } from '../../../models/auto-outgoing-rule';

import { AutoOutgoingRuleService } from '../../../services/auto_rules/auto-outgoing-rule.service';
import { NotyService } from '../../../services/common/noty.service';

import { MatterSearchComponent } from '../../common/matter-search/matter-search.component';
import { DocumentTypeSearchComponent } from '../../common/document-type-search/document-type-search.component';

declare var swal: any;

@Component({
  selector: 'app-auto-outgoing-rule-index',
  templateUrl: './auto-outgoing-rule-index.component.html',
  styleUrls: ['./auto-outgoing-rule-index.component.scss'],
})
export class AutoOutgoingRuleIndexComponent implements OnInit {
  @ViewChild('sidebar_matter_search', { static: true }) sidebarMatterSearch: MatterSearchComponent;
  @ViewChild('sidebar_document_type_search', { static: true }) sidebarDocumentTypeSearch: DocumentTypeSearchComponent;

  autoOutgoingRules: Array<AutoOutgoingRule> = [];

  deletingAutoOutgoingRule: boolean = false;

  count: number = 0;

  loading: boolean = true;

  searchParams: any = { per_page: 20 };

  selectedAutoOutgoingRule: AutoOutgoingRule;

  /**
   * Indicates if sidebar is to be shown for smaller width screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  constructor(private notyService: NotyService, private router: Router, private autoOutgoingRuleService: AutoOutgoingRuleService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loading = true;
    this.autoOutgoingRuleService
      .searchOptions()
      .then((response_json) => {
        this.searchParams = response_json;
        this.loadAutoOutgoingRules();
      })
      .catch(() => {
        this.loadAutoOutgoingRules();
      });
    this.setInitialSidebarPosition();
  }

  // Event Listeners
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  // Component methods
  clearSearch() {
    this.searchParams.document_type_id = null;
    this.searchParams.matter_id = null;
    if (this.sidebarMatterSearch) this.sidebarMatterSearch.clearSelectedMatter();
    if (this.sidebarDocumentTypeSearch) this.sidebarDocumentTypeSearch.clearSelectedDocumentType();
  }

  deleteAutoOutgoingRule(autoOutgoingRule: AutoOutgoingRule) {
    let scope: AutoOutgoingRuleIndexComponent = this;
    swal({
      title: 'Remove Auto Outgoing Rule',
      text: `Remove Auto Outgoing Rule ${autoOutgoingRule.id} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed) {
          this.deletingAutoOutgoingRule = true;
          this.autoOutgoingRuleService
            .delete(autoOutgoingRule.id)
            .then((response) => {
              this.deletingAutoOutgoingRule = false;
              if (response.success) {
                this.notyService.notify(response.text || `Removed auto outgoing rule ${autoOutgoingRule.id}`, 'warning');
                this.loadAutoOutgoingRules();
              } else {
                this.notyService.notify(response.text || 'Error removing auto outgoing rule', 'error');
              }
            })
            .catch(() => {
              scope.deletingAutoOutgoingRule = false;
              scope.notyService.notify('Error removing auto outgoing rule', 'error');
            });
        }
      })
      .catch((err: any) => {
        console.log('Delete prompt error', err);
      });
  }

  loadAutoOutgoingRules() {
    this.loading = true;
    this.autoOutgoingRuleService
      .index(this.searchParams)
      .then((response_json) => {
        this.loading = false;
        this.count = response_json.count;
        this.autoOutgoingRules = response_json.auto_outgoing_rules;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  newAutoOutgoingRule() {
    this.router.navigateByUrl('/auto_outgoing_rules/new');
  }

  search(pageNumberEvent: any = null) {
    if (pageNumberEvent) this.searchParams.page = pageNumberEvent.page;
    this.loadAutoOutgoingRules();
  }

  // Functions for UI manipulation using vanilla JS or jQuery

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 10 + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 157;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }

  setInitialSidebarPosition() {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
    let sidebar_position = () => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    };
    for (var i = 1; i < 20; i += 1) setTimeout(sidebar_position, (i * 1000) / 2);
  }
}
